import React from 'react';
import { GovFormWeb } from '@gov-design-system-ce/react-form';
import {
	PageCode,
	useRezaLocale,
	useRezaTemplateListContext,
} from '@gov-nx/module/page';
import {
	ContentLayout,
	ErrorStatusBanner,
	HeaderSearchBar,
	InfoBanner,
	KeyValues,
	Tile,
	Tiles,
} from '@gov-nx/ui/web';
import { pageRouteResolver } from '@gov-nx/web';
import { CmsPageRender } from '../../../../Cms/CmsPageRender';
import { RezaTemplateListSkeleton } from './RezaTemplateListSkeleton';

export const RezaTemplateList = () => {
	const { t } = useRezaLocale();

	const {
		code,
		isLoading,
		isError,
		templates,
		formDefinition,
		fields,
		onSubmit,
	} = useRezaTemplateListContext();

	return (
		<CmsPageRender
			code={PageCode['reza']}
			override={{ name: t('sablony.seznam.title') }}>
			<ContentLayout>
				<GovFormWeb
					formDefinition={formDefinition}
					onSubmit={onSubmit}>
					<HeaderSearchBar fields={fields} />
				</GovFormWeb>

				{isLoading ? (
					<RezaTemplateListSkeleton />
				) : isError ? (
					<ErrorStatusBanner code={code} />
				) : templates.length === 0 ? (
					<InfoBanner
						headline={t('stav.chyba.zadny-zaznam')}
						text={t('stav.chyba.v-reza-nejsou-data')}
					/>
				) : (
					<Tiles>
						{templates.map((template) => (
							<Tile
								key={template.kod}
								name={template.nazev ?? ''}
								to={pageRouteResolver('reza.templates.detail', {
									id: template.kod,
								})}
								icon={{ name: 'chevron-right', type: 'components' }}>
								<div className="text-(--text-secondary)!">
									<KeyValues
										options={[
											{
												label: t('sablony.seznam.item.popis'),
												value: template.popis ?? '-',
											},
										]}
									/>
								</div>
							</Tile>
						))}
					</Tiles>
				)}
			</ContentLayout>
		</CmsPageRender>
	);
};
